import getConstructorBrowseClient from './constructor-browse-client';
import mapConstructorProduct from './map-constructor-product';

// Bare numeric tail regardless of whether the id arrived as a full GID or
// already-bare — lets ids from different sources (Constructor vs Shopify
// GraphQL vs classic cart) compare equal.
const bareId = (id) => {
  const str = String(id);
  return str.includes('/ProductVariant/') ? str.split('/ProductVariant/')[1] : str;
};

// Define the utility library
const ShopifyUtil = (() => {
  // Main function to fetch product data. Sourced from Constructor's index
  // (browse-by-item-id) rather than the Shopify Storefront GraphQL API —
  // Constructor indexes Shopify items using the real Shopify product id as
  // their own item id, so this needs no Storefront API token at all.
  const getProductData = async (productId) => {
    try {
      const response = await getConstructorBrowseClient().browse.getBrowseResultsForItemIds([String(productId)]);
      const item = response?.response?.results?.[0];
      if (!item) return {};
      return { product: mapConstructorProduct(item) };
    } catch (error) {
      return {};
    }
  };

  // Helper function to find a variant by ID
  const findVariantById = (variants, id) => variants?.find((variant) => bareId(variant.id) === bareId(id)) || null;

  // Function to process the product data and find the appropriate variant
  const processLineProductData = (lineProductData, variantId) =>
    findVariantById(lineProductData.product?.variants, variantId);

  // Function to get product pricing information
  const getProductPricing = async (productId) => {
    const productData = await getProductData(productId);

    if (!productData.product) {
      return {};
    }

    const { id, handle, price, variants } = productData.product;

    return {
      id,
      handle,
      priceRange: { minVariantPrice: { amount: price, currencyCode: 'USD' } },
      variants: variants.map((v) => ({ id: v.id, handle, price: v.price, compareAtPrice: v.compare_at_price })),
    };
  };

  // Attach functions to the window object
  return {
    getProductData,
    getProductPricing,
    processLineProductData,
    findVariantById,
  };
})();

// Make the ShopifyUtil globally accessible
window.ShopifyUtil = ShopifyUtil;

export default ShopifyUtil;
